import {
  DefaultQueryParams,
  environmentBuilder,
  GameLiveConnection,
  parseQuery,
  popupStore,
} from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { gameService } from './GameService';
import { gameName, socketGamePath } from '../enums';
import { SOCKET_EVENTS } from '../enums/socketEvents';
import { gameStore } from '../store';

let start = Number(new Date());
let timeoutId;
const pingInterval = 700;

export class GameConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  async sendGameGetInitialState(isFirst = true) {
    if (isFirst) {
      this.executeConnections();
    }
    await this.sendInitial();
  }

  async sendInitial() {
    const { gameTypeId } = gameConfigStore;
    const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);
    const GetPascalInitialState = 'GetPascalInitialState';
    await super.sendGetInitialState({ partnerId, gameTypeId }, GetPascalInitialState);
  }

  handleInitialResult(data) {
    if (!data || !data.gameTypeInfos[0].roundInfo) {
      const { gameTypeId } = gameConfigStore;
      const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);
      const GetPascalInitialState = 'GetPascalInitialState';
      setTimeout(() => {
        super.sendGetInitialState({ partnerId, gameTypeId }, GetPascalInitialState).then(() => {});
      }, 500);
    } else {
      gameService.onGetInitialStateResult.call(gameService, data);
    }
  }

  // onCashOutResult(handler) {
  //   super.on('CashoutResult', handler);
  // }

  onDoBetResultQueue(handler) {
    super.on(SOCKET_EVENTS.DO_BET_RESULT_QUEUE, handler);
  }

  onCashOutResultQueue(handler) {
    super.on(SOCKET_EVENTS.CASH_OUT_RESULT_QUEUE, handler);
  }

  cashOut(data) {
    super.invoke('CashOut', data);
  }

  sendPing() {
    start = Number(Date.now());
    gameStore.setIsPongReceived(false);
    super.invoke('Ping');
    timeoutId = setTimeout(() => {
      if (!gameStore.isPongReceived) {
        popupStore.toggleSlowConnection(true);
      }
    }, pingInterval);
  }

  getPong() {
    const currentTime = Number(Date.now()) - start;
    gameStore.setIsPongReceived(true);
    if (currentTime > pingInterval) {
      popupStore.toggleSlowConnection(true);
      timeoutId && clearTimeout(timeoutId);
    } else {
      popupStore.toggleSlowConnection(false);
    }
  }

  executeConnections() {
    // INITIAL
    super.onGetInitialStateResult(this.handleInitialResult.bind(this));
    // INITIAL
    super.onFreeBetAwarded();
    super.onFreeBetEnded();
    super.onFreeBetCountUpdate();
    super.onGameOpen();
    super.onLobbyUsersCount();
    super.onBetsClosed(gameService.handleBetsClosed.bind(gameService));
    super.onRoundFinished(gameService.handleRoundFin.bind(gameService));
    super.onDoBetResult(gameService.handleDoBetResult.bind(gameService));
    super.onRoundStarted(gameService.handleRoundStart.bind(gameService));
    super.onResultReport(gameService.handleResultReport.bind(gameService));
    super.onPing(this.getPong);
    super.onCashOutResult(gameService.handleCashOutResult.bind(gameService));
    super.onDoBetResultValidation(gameService.handleDoBetResultValidation.bind(gameService));
    super.onBalanceUpdate();
    super.onGetBalanceResult();
    super.onGetUserBetsHistoryResult();
    super.onMaintenanceNotify();
    super.onReconnecting(gameService.handleReconnecting.bind(gameService));
    super.onReconnected(gameService.handleReconnected.bind(gameService));
    super.onClose(gameService.handleConnectionError.bind(gameService));
  }
}

const { socketUrl } = environmentBuilder(gameName);

const url = (path) => ({ url: `${socketUrl}${path}` });

export const gameLiveConnection = new GameConnection(url(socketGamePath));
